<template>
  <div v-if="addresses.length > 0">
    <div class="title">
      <h3 class="left">Adresses</h3>
    </div>
    <div class="general-lists">
      <div class="table-responsive">
        <div id="basicTable_wrapper" class="dataTables_wrapper form-inline no-footer">
          <table class="table table-hover dataTable no-footer" id="basicTable" role="grid">
            <tbody>
            <tr v-for="(address, idx) in filteredAddresses" :key="'address'+idx">
              <td class="v-align-top">
                <span>{{decodeUsage(address, false)}}</span>
              </td>
              <td class="v-align-top" :colspan="addressColspan(address)">
                <ul>
                  <li v-if="address.corporation_name">{{address.corporation_name}}</li>
                  <li v-if="address.first_name && address.last_name">{{address.first_name}} {{address.last_name}}</li>

                  <li>{{address.street_line1}}</li>
                  <li v-if="address.street_line2">{{address.street_line2}}</li>
                  <li>{{address.zipcode}} {{address.city}}</li>
                  <li v-if="address.decoded_state">{{address.decoded_state}}</li>
                  <li v-if="address.decoded_country">{{address.decoded_country}}</li>
                </ul>
              </td>
              <td v-if="address.customer_usage !== 'main'">
                <button class="btn btn-default btn-sm" v-if="(correspondingAddressEditable && address.customer_usage == 'corresponding') || address.customer_usage != 'corresponding'"
                  @click="$emit('edit', address.id)">Modifier</button>
              </td>
            </tr>
            <!-- <tr v-if="missingAccountingAddress" class="text-danger">
              <td class="v-align-top">
                <span>Adresse de comptabilité</span>
              </td>
              <td class="v-align-top">Aucune</td>
              <td>
                <button class="btn btn-danger btn-sm" @click="$emit('create', 'accounting')">
                  Ajouter
                </button>
              </td>
            </tr> -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .table {
    tbody {
      tr {
        td {
          padding: 5px;
          border: 0;
          &:first-child {
            color: #AAA;
            text-transform: capitalize;
          }
          ul {
            padding:0;
            li {
              list-style-type: none;
            }
          }
        }
      }
      tr.text-danger {
        td {
          color: inherit;
        }
      }
    }
  }
</style>

<script type="text/babel">
  import addressMixin from 'mixins/address'
  import {mapActions, mapState} from "vuex"

  export default {

    mixins: [addressMixin],

    props: {
      main: Object,
      billing: Object,
      addresses: {
        type: Array,
        default: []
      },
      edition: {
        type: Boolean,
        default: true
      },
      correspondingAddressEditable:{
        type:Boolean,
        default:false,
      },
    },

    computed: {
      // missingAccountingAddress() {
      //   return _.find(this.addresses, address => address.customer_usage === "accounting") == undefined
      // },

      filteredAddresses() {
        const customerUsages = ['main', 'corresponding']

        return _.filter(this.addresses, function(address) { 
          return 'customer' == address.type && customerUsages.indexOf(address.customer_usage) != -1 
        })
      }
    },

    methods: {
      addressColspan(address) {
        return address.customer_usage === "main" ? 2 : 1
      }
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Addresses.vue